import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { toast, Toaster } from 'sonner';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ ChamaLink is ready for offline use!');
  },
  onUpdate: (registration) => {
    console.log('🔄 New version available!');
    
    // Show a toast with update option
    toast.info('New version available!', {
      description: 'Click to update to the latest version',
      duration: 10000,
      action: {
        label: 'Update Now',
        onClick: () => {
          // Tell the waiting SW to activate
          if (registration && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          }
          // Reload after a short delay
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      }
    });
  }
});
